import React, { useState, useEffect, useRef, Suspense } from "react";
import {
   BrowserRouter as Router,
   Switch,
   Route,
   useHistory,
   useLocation
} from "react-router-dom";
import PageContact from "./page_contact";
import { trackEvent, trackPageView } from "./track_event";
import PageDrumTrainer from "./page_drum_trainer";
import PageDrumTrainerDeleteAccount from "./page_drum_trainer_delete_account";
import PageFeedMeWeather from "./page_feed_me_weather";
import PageShabibi from "./page_shabibi";
import PageMsnAngel from "./page_msn_angel";
import PageScanAndSpeak from "./page_scan_and_speak";
import PageFeedYourGiant from "./page_feed_your_giant";
import PageLineTimer from "./page_line_timer";
import WinampPlayer from "./winamp";
import MsnMessenger from "./msn_messenger";
import useWindowDrag from "./use_window_drag";
import styles from "./styles.module.css";

export default PageStart

const CounterStrike = React.lazy(() => import("./counter_strike"));

const msnAngelAlbums = [
   { name: "Archive 7", id: "7J5WHzChdb36MO9PZvFCyS" },
   { name: "Cyber City", id: "4o4vVZwNKUaNiJqOgdZIR6" },
   { name: "Archive 6", id: "6vd1nEs7CP83bTCHRF4LDx" },
   { name: "Jeg møtte et spøkelse", id: "5MOfSEPiplbdcRuhiMeqW5" },
   { name: "Archive 5", id: "0cgIRsE0bcgwYFkNZ9Pyb4" },
   { name: "Archive 4", id: "4lqgfiWXguabqNtMtxiG4W" },
   { name: "Archive 3", id: "0KUNCm3W4hBNgdjKVVH4gE" },
   { name: "Archive 2", id: "5zSlVUophOPNPOHhoCTLlF" },
   { name: "Archive 1", id: "0HFuQq3V7dKzbPw9MvVyZ9" },
   { name: "userh309", id: "2nw62TzFtLGGE3UVJHBZJE" },
   { name: "hotel florida", id: "2xSefP7bV8tb57CXKUpnEa" },
   { name: "Taxi Bear", id: "267l4kEncX5yCUSJAygV8K" },
   { name: "lost in the dark", id: "7y4CeQljZYWZG3cfGyjRYz" },
   { name: "Urban Texas Cowboy", id: "6KUh60efOvi6ceVd3NxiGX" },
];

const searchableItems = [
   { name: "Shabibi", path: "/shabibi", type: "📁" },
   { name: "MSN Angel", path: "/msn-angel", type: "📁" },
   { name: "Scan and Speak", path: "/shabibi", type: "📄" },
   { name: "Drum Trainer", path: "/shabibi", type: "📄" },
   { name: "Feed Me Weather", path: "/shabibi", type: "📄" },
   { name: "Feed Your Giant", path: "/shabibi", type: "📄" },
   { name: "Line Timer", path: "/shabibi", type: "📄" },
   ...msnAngelAlbums.map(a => ({ name: a.name, path: "/msn-angel", type: "🎵" as const })),
   { name: "Contact", path: "/contact", type: "📋" },
];

function WindowsLogo() {
   return (
      <div className={styles.bgLogo}>
         <svg width="200" height="220" viewBox="0 0 200 220" xmlns="http://www.w3.org/2000/svg">
            <defs>
               <linearGradient id="red" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#FF0000" />
                  <stop offset="100%" stopColor="#CC0000" />
               </linearGradient>
               <linearGradient id="green" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#00CC00" />
                  <stop offset="100%" stopColor="#009900" />
               </linearGradient>
               <linearGradient id="blue" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#0066FF" />
                  <stop offset="100%" stopColor="#0044CC" />
               </linearGradient>
               <linearGradient id="yellow" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#FFCC00" />
                  <stop offset="100%" stopColor="#FF9900" />
               </linearGradient>
            </defs>
            <path d="M 20 30 Q 45 15, 70 25 L 70 85 Q 45 75, 20 90 Z" fill="url(#red)" />
            <path d="M 80 22 Q 105 10, 130 18 L 130 78 Q 105 70, 80 82 Z" fill="url(#green)" />
            <path d="M 20 100 Q 45 85, 70 95 L 70 155 Q 45 145, 20 160 Z" fill="url(#blue)" />
            <path d="M 80 92 Q 105 80, 130 88 L 130 148 Q 105 140, 80 152 Z" fill="url(#yellow)" />
            <circle cx="160" cy="90" r="28" fill="none" stroke="white" strokeWidth="3" />
            <circle cx="152" cy="82" r="3" fill="white" />
            <circle cx="168" cy="82" r="3" fill="white" />
            <path d="M 148 97 Q 160 108, 172 97" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
         </svg>
         <div className={styles.bgLogoText}>windows<span className={styles.bgLogoYear}>2001</span></div>
      </div>
   );
}

function Clock() {
   const [time, setTime] = useState(new Date());

   useEffect(() => {
      const timer = setInterval(() => setTime(new Date()), 60000);
      return () => clearInterval(timer);
   }, []);

   return (
      <span className={styles.clock}>
         {time.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
      </span>
   );
}

function CounterStrikeIcon() {
   return (
      <svg className={styles.counterStrikeIconImg} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
         <circle cx="24" cy="24" r="21" fill="#e2d3b4" stroke="#151515" strokeWidth="4" />
         <path d="M10 43 Q11 31 21 30 L28 30 Q37 31 39 43 Z" fill="#151515" />
         <rect x="17.5" y="19" width="13" height="10" rx="3" fill="#151515" />
         <path d="M14.5 19.5 Q15 9 24 9 Q33 9 33.5 19.5 Z" fill="#151515" />
         <rect x="13.5" y="18.5" width="21" height="2" rx="1" fill="#151515" />
         <circle cx="21" cy="22.5" r="2.1" fill="#e2d3b4" />
         <circle cx="27" cy="22.5" r="2.1" fill="#e2d3b4" />
         <path
            transform="rotate(-8 25 32)"
            d="M5 30.5 L13.5 29.5 L14 29 L29 29 L29 29.8 L36 29.8 L36 30.4 L41.5 30.4 L41.5 28.8 L42.6 28.8 L42.6 30.4 L45 30.4 L45 31.6 L36 31.6 L36 32.6 L29 32.6 L28.6 33 L27.6 33 Q27.4 36.5 25.6 39.6 L22.6 38.8 Q24.2 36 24.2 33 L20 33 L19 37.4 L16.4 37 L17.2 33 L14 33 L6.5 36.2 Z"
            fill="#151515"
            stroke="#e2d3b4"
            strokeWidth="1.1"
            strokeLinejoin="round"
            paintOrder="stroke"
         />
      </svg>
   );
}

function MsnBuddyIcon() {
   return (
      <svg className={styles.messengerIconImg} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
         <defs>
            <radialGradient id="msnBlue" cx="35%" cy="30%" r="70%">
               <stop offset="0%" stopColor="#d6ecff" />
               <stop offset="45%" stopColor="#4c9df0" />
               <stop offset="100%" stopColor="#0b4fb3" />
            </radialGradient>
            <radialGradient id="msnGreen" cx="35%" cy="30%" r="70%">
               <stop offset="0%" stopColor="#e6ffd0" />
               <stop offset="45%" stopColor="#5ccc2c" />
               <stop offset="100%" stopColor="#1f7a0c" />
            </radialGradient>
         </defs>
         <circle cx="17" cy="11" r="7" fill="url(#msnBlue)" stroke="#06306e" strokeWidth="1" />
         <path d="M5 34 Q5 20 17 20 Q29 20 29 34 Z" fill="url(#msnBlue)" stroke="#06306e" strokeWidth="1" />
         <circle cx="30" cy="19" r="7.5" fill="url(#msnGreen)" stroke="#145208" strokeWidth="1" />
         <path d="M17 44 Q17 28 30 28 Q43 28 43 44 Z" fill="url(#msnGreen)" stroke="#145208" strokeWidth="1" />
      </svg>
   );
}

function FolderIcon() {
   return (
      <div className={styles.folderIcon}>
         <div className={styles.folderTab} />
         <div className={styles.folderBody} />
      </div>
   );
}

function DesktopIcon({ to, label }: { to: string; label: string }) {
   const history = useHistory();
   return (
      <div className={styles.desktopIcon} onClick={(e) => { e.stopPropagation(); history.push(to); }}>
         <FolderIcon />
         <div className={styles.iconLabel}>{label}</div>
      </div>
   );
}

function StartMenu({ onClose, onNavigate }: { onClose: () => void; onNavigate: (path: string) => void }) {
   const [query, setQuery] = useState("");
   const results = query.length > 0
      ? searchableItems.filter(item => item.name.toLowerCase().includes(query.toLowerCase()))
      : [];

   return (
      <div className={styles.startMenu} onClick={(e) => e.stopPropagation()}>
         <div className={styles.startMenuSidebar}>
            <span className={styles.startMenuSidebarText}>windows2001</span>
         </div>
         <div className={styles.startMenuItems}>
            <div style={{ padding: "4px 8px", fontWeight: "bold", fontSize: "14px" }}>
               🔍 Search
            </div>
            <input
               className={styles.startMenuInput}
               placeholder="Search..."
               value={query}
               onChange={(e) => setQuery(e.target.value)}
               autoFocus
            />
            {results.length > 0 && (
               <div className={styles.searchResults}>
                  {results.slice(0, 5).map((item, i) => (
                     <div
                        key={i}
                        className={styles.searchResult}
                        onClick={() => { onNavigate(item.path); onClose(); }}
                     >
                        <span>{item.type}</span>
                        <span>{item.name}</span>
                     </div>
                  ))}
               </div>
            )}
            <div className={styles.startMenuDivider} />
            <a href="mailto:erikandresen10@gmail.com" className={styles.startMenuItem} onClick={onClose}>
               <span className={styles.startMenuIcon}>📧</span>
               <span>E-mail</span>
            </a>
            <div className={styles.startMenuDivider} />
            <div className={styles.startMenuItem} onClick={() => { onNavigate("/contact"); onClose(); }}>
               <span className={styles.startMenuIcon}>📋</span>
               <span>Contact</span>
            </div>
         </div>
      </div>
   );
}

function WindowWrapper({ title, path, onClose, children, itemCount, tall }: {
   title: string;
   path: string;
   onClose: () => void;
   children: React.ReactNode;
   itemCount?: number;
   tall?: boolean;
}) {
   const [maximized, setMaximized] = useState(false);
   const { dragStyle, onTitleBarPointerDown } = useWindowDrag();

   const windowClass = maximized
      ? styles.windowMaximized
      : tall ? styles.windowTall : styles.window;

   return (
      <div className={styles.windowOverlay}>
         <div className={windowClass} style={maximized ? undefined : dragStyle}>
            <div className={styles.titleBar} onPointerDown={onTitleBarPointerDown}>
               <span>{title}</span>
               <div className={styles.titleBarButtons}>
                  <span className={styles.titleBarButton} onClick={onClose}>_</span>
                  <span className={styles.titleBarButton} onClick={() => setMaximized(!maximized)}>□</span>
                  <span className={styles.titleBarButton} onClick={onClose}>✕</span>
               </div>
            </div>
            <div className={styles.addressBar}>
               <span className={styles.addressBarLabel}>Address</span>
               <div className={styles.addressBarInput}>{path}</div>
            </div>
            <div className={styles.windowContent}>
               {children}
            </div>
            <div className={styles.statusBar}>
               {itemCount !== undefined ? `${itemCount} object(s)` : "Ready"}
            </div>
         </div>
      </div>
   );
}

function AppContent() {
   const [startOpen, setStartOpen] = useState(false);
   const [winampOpen, setWinampOpen] = useState(false);
   const [messengerOpen, setMessengerOpen] = useState(false);
   const [counterStrikeOpen, setCounterStrikeOpen] = useState(false);
   const [windowOnTop, setWindowOnTop] = useState<"page" | "winamp" | "messenger" | "counterStrike">("page");
   const history = useHistory();
   const location = useLocation();
   const isHome = location.pathname === "/";

   const closeWindow = () => history.push("/");
   const firstPageWasCounted = useRef(false);

   useEffect(() => {
      function trackLinkClick(event: MouseEvent) {
         const link = (event.target as Element | null)?.closest?.("a[href]");
         if (link) trackEvent(`link: ${link.getAttribute("href")}`);
      }

      document.addEventListener("click", trackLinkClick, true);
      return () => document.removeEventListener("click", trackLinkClick, true);
   }, []);

   useEffect(() => {
      setWindowOnTop("page");
      if (firstPageWasCounted.current) trackPageView(location.pathname);
      firstPageWasCounted.current = true;
   }, [location.pathname]);

   function zIndexFor(windowName: "page" | "winamp" | "messenger" | "counterStrike") {
      return windowOnTop === windowName ? 31 : 30;
   }

   return (
      <div className={styles.desktop} onClick={() => { if (startOpen) setStartOpen(false); }}>
         <WindowsLogo />
         <div className={styles.desktopArea}>
            <div className={styles.iconRow}>
               <DesktopIcon to="/shabibi" label="Shabibi" />
               <DesktopIcon to="/msn-angel" label="MSN Angel" />
               <div className={styles.winampIcon} onClick={(e) => { e.stopPropagation(); setWinampOpen(true); setWindowOnTop("winamp"); trackEvent("open winamp"); }}>
                  <div className={styles.winampIconImg}>▶</div>
                  <div className={styles.iconLabel}>Winamp</div>
               </div>
               <div className={styles.messengerIcon} onClick={(e) => { e.stopPropagation(); setMessengerOpen(true); setWindowOnTop("messenger"); trackEvent("open msn"); }}>
                  <MsnBuddyIcon />
                  <div className={styles.iconLabel}>MSN</div>
               </div>
               <div className={styles.counterStrikeIcon} onClick={(e) => { e.stopPropagation(); setCounterStrikeOpen(true); setWindowOnTop("counterStrike"); trackEvent("open counter strike"); }}>
                  <CounterStrikeIcon />
                  <div className={styles.iconLabel}>Counter Strike 1.3b</div>
               </div>
            </div>
         </div>

         {!isHome && (
            <div className={winampOpen ? styles.windowLayerBesideWinamp : styles.windowLayer} style={{ zIndex: zIndexFor("page") }} onPointerDown={() => setWindowOnTop("page")}>
               <Switch>
                  <Route path="/shabibi/scanandspeak/privacy">
                     <WindowWrapper title="Scan and Speak - Privacy Policy" path="C:\Shabibi\scanandspeak\privacy.txt" onClose={closeWindow}>
                        <PageScanAndSpeak />
                     </WindowWrapper>
                  </Route>
                  <Route path="/shabibi/drumtrainer/deleteaccount">
                     <WindowWrapper title="Drum Trainer Delete Account" path="C:\Shabibi\drumtrainer\deleteaccount.txt" onClose={closeWindow}>
                        <PageDrumTrainerDeleteAccount />
                     </WindowWrapper>
                  </Route>
                  <Route path="/shabibi/drumtrainer/privacy">
                     <WindowWrapper title="Drum Trainer - Privacy Policy" path="C:\Shabibi\drumtrainer\privacy.txt" onClose={closeWindow}>
                        <PageDrumTrainer />
                     </WindowWrapper>
                  </Route>
                  <Route path="/shabibi/feedmeweather/privacy">
                     <WindowWrapper title="Feed Me Weather - Privacy Policy" path="C:\Shabibi\feedmeweather\privacy.txt" onClose={closeWindow}>
                        <PageFeedMeWeather />
                     </WindowWrapper>
                  </Route>
                  <Route path="/shabibi/feedyourgiant/privacy">
                     <WindowWrapper title="Feed Your Giant - Privacy Policy" path="C:\Shabibi\feedyourgiant\privacy.txt" onClose={closeWindow}>
                        <PageFeedYourGiant />
                     </WindowWrapper>
                  </Route>
                  <Route path="/shabibi/linetimer/privacy">
                     <WindowWrapper title="Line Timer - Privacy Policy" path="C:\Shabibi\linetimer\privacy.txt" onClose={closeWindow}>
                        <PageLineTimer />
                     </WindowWrapper>
                  </Route>
                  <Route path="/shabibi">
                     <WindowWrapper title="Shabibi" path="C:\Shabibi" onClose={closeWindow} itemCount={5}>
                        <PageShabibi />
                     </WindowWrapper>
                  </Route>
                  <Route path="/msn-angel">
                     <WindowWrapper title="MSN Angel" path="C:\MSN Angel" onClose={closeWindow} itemCount={14}>
                        <PageMsnAngel />
                     </WindowWrapper>
                  </Route>
                  <Route path="/contact">
                     <WindowWrapper title="Contact" path="C:\Contact" onClose={closeWindow}>
                        <PageContact />
                     </WindowWrapper>
                  </Route>
               </Switch>
            </div>
         )}

         {winampOpen && (
            <div className={styles.windowLayer} style={{ zIndex: zIndexFor("winamp") }} onPointerDown={() => setWindowOnTop("winamp")}>
               <WinampPlayer onClose={() => setWinampOpen(false)} />
            </div>
         )}

         {messengerOpen && (
            <div className={styles.windowLayer} style={{ zIndex: zIndexFor("messenger") }} onPointerDown={() => setWindowOnTop("messenger")}>
               <MsnMessenger onClose={() => setMessengerOpen(false)} />
            </div>
         )}

         {counterStrikeOpen && (
            <div className={styles.windowLayer} style={{ zIndex: zIndexFor("counterStrike") }} onPointerDown={() => setWindowOnTop("counterStrike")}>
               <Suspense fallback={null}>
                  <CounterStrike onClose={() => setCounterStrikeOpen(false)} />
               </Suspense>
            </div>
         )}

         {startOpen && (
            <StartMenu
               onClose={() => setStartOpen(false)}
               onNavigate={(path) => history.push(path)}
            />
         )}
         <div className={styles.taskbar}>
            <div
               className={startOpen ? styles.startButtonActive : styles.startButton}
               onClick={(e) => { e.stopPropagation(); setStartOpen(!startOpen); }}
            >
               <span className={styles.windowsLogo}>⊞</span>
               Start
            </div>
            <Clock />
         </div>
      </div>
   );
}

function PageStart() {
   return (
      <Router>
         <AppContent />
      </Router>
   );
}
